// 应用端登录注册页面
export const LOGIN_PAGE = 'LOGIN_PAGE'

export const SYSTEM_URL_PREFIX = '/system'

export const SYSTEM_ACCOUNT_PREFIX = `${SYSTEM_URL_PREFIX}/account`

/** 登录页面 */
export const LOGIN_PAGE_URL = `${SYSTEM_ACCOUNT_PREFIX}/login`

/** 完善信息页面 */
export const PERFECT_PAGE_URL = `${SYSTEM_ACCOUNT_PREFIX}/perfect`

/** 账户待审核页面 */
export const REVIEW_PAGE_URL = `${SYSTEM_ACCOUNT_PREFIX}/review`

/** 绑定微信页面 */
export const BIND_WECHAT_PAGE_URL = `${SYSTEM_ACCOUNT_PREFIX}/bindWechat`

/** 绑定手机页面 */
export const BIND_MOBILE_PAGE_URL = `${SYSTEM_ACCOUNT_PREFIX}/bindMobile`

/** 绑定邮箱页面 */
export const BIND_EMAIL_PAGE_URL = `${SYSTEM_ACCOUNT_PREFIX}/bindEmail`

export const commonPages = [LOGIN_PAGE]

export const NO_NAME_PAGE = '未命名页面'

export const commonPageList = [
    {
        label: '登录页面',
        value: LOGIN_PAGE
    }
]

/** 页面右侧栏类名 */
export const RIGHT_ASIDE_CLASS = 'page-design-aside'

export const commonPageOptions = [
    {
        label: '登录页面',
        value: LOGIN_PAGE,
        group: 'common'
    }
]

/** 页面参数类型选项 */
export const PAGE_PARAMETER_TYPE_OPTIONS = [
    {
        label: '文本',
        value: 'TEXT'
    },
    {
        label: '数值',
        value: 'NUMBER'
    },
    {
        label: '日期',
        value: 'DATE'
    },
    {
        label: '数组',
        value: 'ARRAY'
    },
    {
        label: '布尔',
        value: 'BOOL'
    }
]
